<template>
  <div class="box-div">

    <div class="index-content">
      <div class="index-title">数据管理</div>
      <div class="statInfo-content">
        <div class="statInfo-contentLeft">
          <div class="statInfo">
            <div class="content">
              <div class="content-item">
                <div class="title">试卷 / 试题数量</div>
                <div class='content-data'>{{ indexData.exam_num }} / {{ indexData.exam_ques_num }}</div>
              </div>
              <div class="content-item">
                <div class="title">问卷 / 题库数量</div>
                <div class='content-data'>{{ indexData.question_num }} / {{ indexData.question_title_num }}</div>
              </div>
              <div class="content-item">
                <div class="title">视频征集数量</div>
                <div class='content-data'>{{ indexData.collect_video_num }}</div>
              </div>
              <div class="content-item">
                <div class="title">学校数量</div>
                <div class='content-data'>{{ indexData.school_num || 0 }}</div>
              </div>
              <div class="content-item">
                <div class="title">课程视频数量</div>
                <div class='content-data'>{{ indexData.vedio_num || 0 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="index-title">订单数据</div>
      <div class="statInfo-content">
        <div class="statInfo-contentLeft">
          <div class="statInfo">
            <div class="content">
              <div class="content-item">
                <div class="title">累计订单数量</div>
                <div class='content-data'>{{ indexData.order.total_num || 0 }}</div>
              </div>
              <div class="content-item">
                <div class="title">待发货订单</div>
                <div class='content-data'>{{ indexData.order.drop_num || 0 }}</div>
              </div>
              <div class="content-item">
                <div class="title">已发货订单</div>
                <div class='content-data'>{{ indexData.order.del_num || 0}}</div>
              </div>
              <div class="content-item">
                <div class="title">已完成订单</div>
                <div class='content-data'>{{ indexData.order.com_num || 0 }}</div>
              </div>
              <div class="content-item">
                <div class="title">已退货订单</div>
                <div class='content-data'>{{ indexData.order.ref_num || 0 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import Side from "../common/side.vue";
import common from "@/common/common.js";
import time from "@/common/time.js";
import moment from "moment";
import echarts from "echarts";

export default {
  name: "home",
  components: {},
  data() {
    return {
      indexData: {
        order: {
          total_num: 0,
          drop_num: 0,
          del_num: 0,
          com_num: 0,
          ref_num: 0
        }
      },

    };
  },
  created() {
    this.getData() //获取数据
  },
  methods: {
    getData() {
      this.axios
          .get(this.config.urlArray.orderTotalData, {})
          .then(result => {
            common.ajaxMsg(result.data)
            let resData = result.data.data
            this.indexData = resData
            this.loading = false
          })
          .catch(err => {
            common.msg('error', '数据获取失败', () => {
            })
          })
    }

  }
};
</script>
<style scoped lang="scss">


.box-div {
  padding: 10px 30px 0;

  .index-content {
    .index-title {
      color: rgba(253, 26, 26, 0.65);
      font-size: 16px;
      margin-bottom: 10px;
    }

    .statInfo-content {
      display: flex;

      .statInfo-contentLeft {
        flex: 1;
        margin-right: 20px;

        .content {
          .content-item {
            border-left: 1px solid #ECECEC;
          }

          .content-item:first-child {
            border-left: none;
          }
        }

      }

      .statInfo-contentRight {
        width: 360px;
        background: #FFF;

        .content {
          // height: 100%;
          flex-wrap: wrap;

          > div {
            width: 50%;
          }
        }
      }

      .statInfo {
        margin-bottom: 20px;

        .content {
          padding: 20px;
          background: #FFF;
          display: flex;

          .content-item {
            text-align: center;
            flex: 1;

            .title {
              justify-content: center;
              font-size: 16px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.65);
              line-height: 17px;
              margin-bottom: 20px;
            }

            .content-data {
              font-size: 35px;
              color: #D70D2A;
              line-height: 60px;
            }
          }
        }
      }
    }

  }
}
</style>
